import { Link } from '@inertiajs/react'
import { Eye, Clock, User, ChevronRight } from 'lucide-react'
import type { Article } from '@/types'

interface ArticleCardProps {
  article: Article
  categorySlug: string
}

function formatDate(dateString: string): string {
  const date = new Date(dateString)
  return date.toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })
}

export function ArticleCard({ article, categorySlug }: ArticleCardProps) {
  return (
    <Link
      href={`/content/${categorySlug}/${article.slug}`}
      className="group block bg-white rounded-xl shadow-md p-6 border border-gray-100 hover:border-tessan-primary hover:shadow-lg transition-all"
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-gray-900 group-hover:text-tessan-primary transition-colors line-clamp-2">
            {article.title}
          </h3>

          <p className="mt-2 text-sm text-gray-500 line-clamp-2">
            {article.excerpt}
          </p>

          <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-gray-400">
            <div className="flex items-center gap-1">
              <User className="w-3.5 h-3.5" />
              <span>{article.author.name}</span>
            </div>

            <div className="flex items-center gap-1">
              <Clock className="w-3.5 h-3.5" />
              <span>{article.reading_time} min de lecture</span>
            </div>

            <div className="flex items-center gap-1">
              <Eye className="w-3.5 h-3.5" />
              <span>{article.views_count} {article.views_count === 1 ? 'vue' : 'vues'}</span>
            </div>

            <span className="text-gray-300">•</span>
            <span>{formatDate(article.published_at)}</span>
          </div>
        </div>

        <ChevronRight className="w-5 h-5 text-gray-300 group-hover:text-tessan-primary transition-colors flex-shrink-0 mt-1" />
      </div>
    </Link>
  )
}
